import React, { useMemo, useState } from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useConsumosSuprimentos } from "./consumosData";
import { generatePdfReport } from "../../../utils/pdf/generatePdfReport";

const SuprimentosConsumos: React.FC = () => {
  const headers = [
    "Técnico",
    "Tipo",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useConsumosSuprimentos();

  const columnWidths = [
    "150px", // Técnico
    "80px", // Tipo
    "70px", // Código
    "300px", // Nome
    "60px", // Quantidade
    "90px", // Custo
    "90px", // Data
    "60px", // Hora
  ];

  const [selectedColumns, setSelectedColumns] = useState<boolean[]>(
    headers.map(() => true)
  );

  const enabledColumnIndexes = useMemo(
    () =>
      selectedColumns
        .map((checked, i) => (checked ? i : -1))
        .filter((i) => i !== -1),
    [selectedColumns]
  );

  const footerLines = useMemo(() => {
    let totalQuantidade = 0;

    rows.forEach((row) => {
      const qtd = Number(String(row[4] ?? "").replace(",", "."));
      if (isFinite(qtd)) totalQuantidade += qtd;
    });

    return [`Total de Itens Consumidos: ${totalQuantidade}`];
  }, [rows]);

  return (
    <div>
      <TitleButtons
        title="Suprimentos - Consumos"
        buttons={[
          {
            label: "Gerar Relatório",
            onClick: () =>
              generatePdfReport({
                reportTitle: "Relatório de Consumos",
                fileNamePrefix: "Suprimentos-Consumos",
                subtitle:
                  "Relatório de Saída de Materiais para Consumo/Uso Interno",
                headers,
                rows,
                custoColIndex: 5,
                enabledColumns: enabledColumnIndexes,
                footerLines,
              }),
            variant: "secondary",
            dropdownOptions: headers.map((h, i) => ({
              label: h,
              checked: selectedColumns[i],
            })),
            onOptionChange: (index, checked) => {
              const updated = [...selectedColumns];
              updated[index] = checked;
              setSelectedColumns(updated);
            },
          },
        ]}
      />

      {loading ? (
        <div style={{ padding: 16 }}>Carregando consumos…</div>
      ) : (
        <Table headers={headers} rows={rows} columnWidths={columnWidths} />
      )}
    </div>
  );
};

export default SuprimentosConsumos;
